import { SPACING } from "@joonapp/web-shared"
import { JoonUIColor } from "@joonapp/web-shared"
import { Typography } from "@joonapp/web-shared"
import dayjs from "dayjs"
import Skeleton from "react-loading-skeleton"

import CoachRoutineQuestCard from "./CoachRoutineQuestCard"
import { useQuestBoardQuery } from "../../../networking/queries"
import { isCoachQuest } from "../../../util/util"

export const CoachRoutineDaySection = ({
  dayOfWeek,
  dayNumber,
  fullDate,
}: {
  dayOfWeek: string
  dayNumber: string
  fullDate: string
}) => {
  const { data: quests, isLoading } = useQuestBoardQuery(fullDate)

  const questInstances = quests?.filter((quest) => isCoachQuest(quest))

  return (
    <div className="w-full flex flex-col gap-2">
      <div className="w-full flex flex-row gap-1 mb-2 items-center">
        <Typography
          variant="bodySmall"
          style={{
            backgroundColor:
              dayjs().date() === parseInt(dayNumber)
                ? JoonUIColor.background.lightAccent
                : "none",
            padding: `${SPACING.space05} ${SPACING.space1}`,
            borderRadius: SPACING.space1,
          }}
        >
          {dayNumber}
        </Typography>
        <Typography variant="bodySmallBold">{dayOfWeek}</Typography>
        <hr className="w-full" />
      </div>
      {isLoading || !questInstances ? (
        <Skeleton className="w-full h-20" />
      ) : questInstances.length === 0 ? (
        <Typography variant="bodySmall" color={JoonUIColor.text.secondary}>
          No coaching tasks scheduled on this day!
        </Typography>
      ) : (
        questInstances.map((quest) => (
          <CoachRoutineQuestCard key={quest.id} questInstance={quest} />
        ))
      )}
    </div>
  )
}

export default CoachRoutineDaySection
